import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  const [currentCarIndex, setCurrentCarIndex] = useState(0);

  // Hyundai car images with links
  const cars = [
    {
      id: 1,
      name: 'Hyundai i20',
      image: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/i20/Highlights/knight/i20knighthome-pc.jpg',
      link: 'https://www.hyundai.com/in/en/vehicles/i20.html',
      alt: 'Hyundai i20'
    },
    {
      id: 2,
      name: 'Hyundai i20',
      image: 'https://hyperlocal-cms-content.onlinesales.ai/nios_desktop_e4560deac3.jpg',
      link: 'https://www.hyundai.com/in/en/vehicles/i20.html',
      alt: 'Hyundai i20'
    },
    {
      id: 3,
      name: 'Hyundai i20',
      image: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/i20/Highlights/knight/i20knightbig.jpg',
      link: 'https://www.hyundai.com/in/en/vehicles/i20.html',
      alt: 'Hyundai i20 Knight'
    }
  ];

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-scroll cars every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCarIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % cars.length;
        return nextIndex;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [cars.length]);

  return (
    <section className="hero">
      {/* Background Car Carousel */}
      <div className="hero-cars-background">
        <div 
          className="hero-cars-track"
          style={{ 
            transform: `translateX(-${currentCarIndex * 100}vw)`
          }}
        >
          {cars.map((car, index) => (
            <a
              key={car.id}
              href={car.link}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-car-slide"
            >
              <img 
                src={car.image} 
                alt={car.alt}
                className={`hero-car-image ${index === 1 ? 'hero-car-image-second' : ''}`}
                loading="eager"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </a>
          ))}
        </div>
        <div className="hero-overlay"></div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">Authorized Hyundai Dealership</div>
          <h1 className="hero-title">
            <span className="title-line">SHUBH HYUNDAI</span>
            <span className="title-tagline">SALES • SERVICE • SPARES</span>
          </h1>
          <p className="hero-subtitle">Experience premium automotive excellence with India's most trusted brand</p>
          <div className="hero-ctas">
            <a href="tel:+917575808003" className="btn btn-primary">
              <span>Book a Test Drive</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <Link to="/contact" className="btn btn-secondary">Contact Sales</Link>
            <Link to="/contact#service" className="btn btn-outline">Book Service</Link>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

